export enum SessionVariables {
  Auth = 'SCTD_t',
  Refresh = 'IOGAS-refresh',
  LoginCallbackURL = 'IOGAS_loginCallbackURL',
  categories = 'iogas-categories',
  Session = 'session'
}